import { render, staticRenderFns } from "./KnowledgeExamResultForStudent.vue?vue&type=template&id=2b0fd4f2"
import script from "./KnowledgeExamResultForStudent.vue?vue&type=script&lang=ts"
export * from "./KnowledgeExamResultForStudent.vue?vue&type=script&lang=ts"
import style0 from "./KnowledgeExamResultForStudent.vue?vue&type=style&index=0&id=2b0fd4f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_prettier@2.2.1_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports